import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-possibledoubledebits',
  templateUrl: './possibledoubledebits.component.html',
  styleUrls: ['./possibledoubledebits.component.css']
})
export class PossibledoubledebitsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
